import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/shop',
            name: 'village_shop',
            component: () => import("./views/shop.vue"),
            meta: {
            }
        },
    ];
};